import styled from 'styled-components';

import { weights } from 'utils/style';

import Header from 'components/RecurringOrderSuggestionsDiscardReasonsModal/Sections/Header/component';

export default styled(Header)`
  & {
    text-align: center;
  }

  h2 {
    font-size: 20px;
    line-height: 26px;
    color: var(--grey900);
    font-weight: ${weights('medium')};
  }
`;
